import { alpha } from "@mui/material"

const mixins = {
  bottomNavigation: {
    height: 86,
  },
  mobileHeader: {
    height: 56,
  },
  mobileDirectionSearch: {
    width: 380,
  },
  directionCard: {
    height: 195,
  },
  stepCard: {
    height: 236,
  },
  stepOverviewCard: {
    height: 338,
  },
  stepOverviewContent: {
    height: 276,
  },
  bottomGredientPageEffect: {
    height: 198,
  },
  placeDetail: {
    drawerBleeding: {
      height: 176,
    },
  },
}

const createBottomGradientPageEffect = (sx = {}) => {
  return {
    content: "''",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    display: "inline-block",
    background: "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 35%)",

    pointerEvents: "none",
    zIndex: -1,
    ...sx,
  }
}
const BOTTOM_GREDIENT_MAP_PAGE_EFFECT = createBottomGradientPageEffect({
  background: "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 31.72%)",
  height: mixins.bottomGredientPageEffect.height,
  zIndex: -1,
})

export const themeOptionFactory = (theme) => ({
  mixins,
  assets: {
    backIcon: {
      icon_comp: "ArrowLeftIcon",
    },
    fonts: {
      urls: ["/assets/fonts/one-siam/sukhumvit-set.css"],
    },
    startIcon: {
      icon_path:
        "M17.89,10.58a2.2,2.2,0,0,0-3-1.12,2.22,2.22,0,0,0-1.4-1.26A4.83,4.83,0,1,0,7.65,9.31v4.26c-.27-.33-.49-.58-.67-.76a3,3,0,0,0-2-1,2.84,2.84,0,0,0-2.45,1.05.69.69,0,0,0,.06.87c.12.19.6,1.1,2.5,5.44a8.81,8.81,0,0,0,1.55,2.3,2.86,2.86,0,0,1,1,2,.7.7,0,0,0,.71.7H19.23a.7.7,0,0,0,.71-.7c0-1.66,1.12-2.54,1.12-4.92v-6A2.21,2.21,0,0,0,17.89,10.58Zm1.76,8c0,1.85-.85,2.6-1.07,4.22H9c-.35-1.69-1.82-2.31-2.61-4.13-.54-1.22-1.76-4-2.36-5.19a2.12,2.12,0,0,1,1-.2,1.67,1.67,0,0,1,1,.55c.34.34.9,1,1.82,2.19a.7.7,0,0,0,1.25-.44V6H7.65V7.63A3.38,3.38,0,0,1,6.44,5a3.42,3.42,0,0,1,6.84,0,3.32,3.32,0,0,1-.6,1.93,3.13,3.13,0,0,1-.62.69V5.06a2.21,2.21,0,0,0-4.41,0V6H9.06v-1a.8.8,0,0,1,.8-.8.79.79,0,0,1,.79.8v8.25a.7.7,0,0,0,.71.7.7.7,0,0,0,.7-.7v-3a.78.78,0,0,1,.62-.77l.18,0a.79.79,0,0,1,.79.8v3a.7.7,0,0,0,.71.7.7.7,0,0,0,.7-.7V11.43a.79.79,0,0,1,.8-.79.79.79,0,0,1,.79.79v1.88a.7.7,0,0,0,.71.7.7.7,0,0,0,.7-.7v-.75a.8.8,0,0,1,.8-.8.79.79,0,0,1,.79.8Z",
    },
    directionSearch: {
      origin: {},
      destination: {
        icon_path:
          "M12.3281 7.21874C11.1648 7.21874 10.2188 8.16476 10.2188 9.32813C10.2188 10.497 11.1631 11.4375 12.3281 11.4375C13.514 11.4375 14.4375 10.4793 14.4375 9.32813C14.4375 8.16476 13.4915 7.21874 12.3281 7.21874Z M12.3281 3C8.83859 3 6 5.83859 6 9.32813C6 10.5069 6.32651 11.6574 6.94399 12.6554L11.9677 20.7505C12.176 21.0869 12.6671 21.0817 12.8689 20.7433L17.7643 12.57C18.3473 11.593 18.6563 10.4719 18.6563 9.32813C18.6563 5.83859 15.8177 3 12.3281 3ZM12.3281 12.4992C10.5582 12.4992 9.15703 11.0586 9.15703 9.32813C9.15703 7.58335 10.5834 6.15703 12.3281 6.15703C14.0729 6.15703 15.4992 7.58335 15.4992 9.32813C15.4992 11.0433 14.1169 12.4992 12.3281 12.4992Z",
      },
      clear: {
        icon_path:
          "M12.0469 0C5.45578 0 0 5.36204 0 11.9531C0 18.5442 5.45578 24 12.0469 24C18.638 24 24 18.5442 24 11.9531C24 5.36204 18.638 0 12.0469 0ZM17.9634 15.8808C18.5119 16.4292 18.5119 17.3213 17.9634 17.8702C17.4192 18.4139 16.5272 18.4228 15.9741 17.8702L12.0469 13.9416L8.02546 17.8706C7.47704 18.4191 6.585 18.4191 6.0361 17.8706C5.48766 17.3222 5.48766 16.4302 6.0361 15.8812L9.96422 11.9531L6.0361 8.025C5.48766 7.4761 5.48766 6.58406 6.0361 6.03562C6.585 5.48718 7.47704 5.48718 8.02546 6.03562L12.0469 9.96468L15.9741 6.03562C16.5216 5.48812 17.4136 5.48624 17.9634 6.03562C18.5119 6.58406 18.5119 7.4761 17.9634 8.025L14.0353 11.9531L17.9634 15.8808Z",
      },
      connector: {},
    },
    navigation: {
      origin: {
        icon_path:
          "M11.8012 12.0004C12.3878 12.0004 12.8901 11.7868 13.3079 11.3595C13.7256 10.9322 13.9345 10.4186 13.9345 9.81858C13.9345 9.21858 13.7256 8.70495 13.3079 8.27766C12.8901 7.8504 12.3878 7.63677 11.8012 7.63677C11.2145 7.63677 10.7123 7.8504 10.2945 8.27766C9.87673 8.70495 9.66785 9.21858 9.66785 9.81858C9.66785 10.4186 9.87673 10.9322 10.2945 11.3595C10.7123 11.7868 11.2145 12.0004 11.8012 12.0004ZM11.8012 20.0186C13.9701 17.9822 15.579 16.1322 16.6278 14.4686C17.6767 12.805 18.2012 11.3277 18.2012 10.0368C18.2012 8.05494 17.5834 6.43221 16.3478 5.16858C15.1123 3.90495 13.5967 3.27312 11.8012 3.27312C10.0056 3.27312 8.49006 3.90495 7.25451 5.16858C6.01896 6.43221 5.40117 8.05494 5.40117 10.0368C5.40117 11.3277 5.92562 12.805 6.97452 14.4686C8.02339 16.1322 9.6323 17.9822 11.8012 20.0186ZM11.8012 22.9095C8.93894 20.4186 6.80116 18.1049 5.38784 15.9686C3.97451 13.8322 3.26784 11.8549 3.26784 10.0368C3.26784 7.3095 4.12562 5.13675 5.84117 3.51858C7.55673 1.9004 9.54339 1.09131 11.8012 1.09131C14.059 1.09131 16.0456 1.9004 17.7612 3.51858C19.4767 5.13675 20.3345 7.3095 20.3345 10.0368C20.3345 11.8549 19.6278 13.8322 18.2145 15.9686C16.8012 18.1049 14.6634 20.4186 11.8012 22.9095Z",
      },
      destination: {
        icon_path:
          "M11.8012 12.0004C12.3878 12.0004 12.8901 11.7868 13.3079 11.3595C13.7256 10.9322 13.9345 10.4186 13.9345 9.81858C13.9345 9.21858 13.7256 8.70495 13.3079 8.27766C12.8901 7.8504 12.3878 7.63677 11.8012 7.63677C11.2145 7.63677 10.7123 7.8504 10.2945 8.27766C9.87673 8.70495 9.66785 9.21858 9.66785 9.81858C9.66785 10.4186 9.87673 10.9322 10.2945 11.3595C10.7123 11.7868 11.2145 12.0004 11.8012 12.0004ZM11.8012 20.0186C13.9701 17.9822 15.579 16.1322 16.6278 14.4686C17.6767 12.805 18.2012 11.3277 18.2012 10.0368C18.2012 8.05494 17.5834 6.43221 16.3478 5.16858C15.1123 3.90495 13.5967 3.27312 11.8012 3.27312C10.0056 3.27312 8.49006 3.90495 7.25451 5.16858C6.01896 6.43221 5.40117 8.05494 5.40117 10.0368C5.40117 11.3277 5.92562 12.805 6.97452 14.4686C8.02339 16.1322 9.6323 17.9822 11.8012 20.0186ZM11.8012 22.9095C8.93894 20.4186 6.80116 18.1049 5.38784 15.9686C3.97451 13.8322 3.26784 11.8549 3.26784 10.0368C3.26784 7.3095 4.12562 5.13675 5.84117 3.51858C7.55673 1.9004 9.54339 1.09131 11.8012 1.09131C14.059 1.09131 16.0456 1.9004 17.7612 3.51858C19.4767 5.13675 20.3345 7.3095 20.3345 10.0368C20.3345 11.8549 19.6278 13.8322 18.2145 15.9686C16.8012 18.1049 14.6634 20.4186 11.8012 22.9095Z",
      },
      start: {
        icon_path:
          "M19.7904 3.61714L14.148 18.4323L12.1277 11.2798L4.97529 9.25951L19.7904 3.61714ZM22.0438 2.95833C22.4235 1.96136 21.4464 0.984051 20.4494 1.36369L2.51416 8.19435C1.40181 8.61799 1.47275 10.2148 2.61805 10.5383L10.6115 12.796L12.8693 20.7894C13.1927 21.9339 14.7894 22.0064 15.2132 20.8934L22.0438 2.95833Z",
      },
      step: {
        icon_path:
          "M6.96484 2.83105C6.96484 2.41684 7.30063 2.08105 7.71484 2.08105H19.3115C19.7257 2.08105 20.0615 2.41684 20.0615 2.83105C20.0615 3.24526 19.7257 3.58105 19.3115 3.58105H7.71484C7.30063 3.58105 6.96484 3.24526 6.96484 2.83105Z M6.96484 9.5449C6.96484 9.13069 7.30063 8.7949 7.71484 8.7949H19.3115C19.7257 8.7949 20.0615 9.13069 20.0615 9.5449C20.0615 9.95911 19.7257 10.2949 19.3115 10.2949H7.71484C7.30063 10.2949 6.96484 9.95911 6.96484 9.5449Z M6.96484 16.2588C6.96484 15.8446 7.30063 15.5088 7.71484 15.5088H19.3115C19.7257 15.5088 20.0615 15.8446 20.0615 16.2588C20.0615 16.673 19.7257 17.0088 19.3115 17.0088H7.71484C7.30063 17.0088 6.96484 16.673 6.96484 16.2588Z M0.25 2.83111C0.25 1.40563 1.40555 0.25 2.83106 0.25C4.25656 0.25 5.41211 1.40563 5.41211 2.83111C5.41211 4.25659 4.25656 5.41222 2.83106 5.41222C1.40555 5.41222 0.25 4.25659 0.25 2.83111ZM2.83106 1.75C2.23402 1.75 1.75 2.23401 1.75 2.83111C1.75 3.42821 2.23402 3.91222 2.83106 3.91222C3.42808 3.91222 3.91211 3.42821 3.91211 2.83111C3.91211 2.23401 3.42808 1.75 2.83106 1.75Z M0.25 9.545C0.25 8.11952 1.40555 6.96387 2.83106 6.96387C4.25657 6.96387 5.41211 8.11952 5.41211 9.545C5.41211 10.9705 4.25655 12.1261 2.83106 12.1261C1.40556 12.1261 0.25 10.9705 0.25 9.545ZM2.83106 8.46387C2.23403 8.46387 1.75 8.94788 1.75 9.545C1.75 10.1421 2.23402 10.6261 2.83106 10.6261C3.42809 10.6261 3.91211 10.1421 3.91211 9.545C3.91211 8.94788 3.42807 8.46387 2.83106 8.46387Z M0.25 16.2588C0.25 14.8334 1.40554 13.6777 2.83106 13.6777C4.25658 13.6777 5.41211 14.8334 5.41211 16.2588C5.41211 17.6842 4.2566 18.84 2.83106 18.84C1.40551 18.84 0.25 17.6842 0.25 16.2588ZM2.83106 15.1777C2.23404 15.1777 1.75 15.6618 1.75 16.2588C1.75 16.856 2.23407 17.34 2.83106 17.34C3.42804 17.34 3.91211 16.856 3.91211 16.2588C3.91211 15.6618 3.42806 15.1777 2.83106 15.1777Z",
      },
    },
    empty: {
      promotions: {
        icon_path:
          "M22.1797 5.21149H16.7162C17.0357 4.86138 17.2497 4.42811 17.3336 3.96163C17.4175 3.49516 17.3678 3.01447 17.1904 2.57499C17.0129 2.1355 16.7149 1.75511 16.3306 1.47767C15.9464 1.20023 15.4915 1.03703 15.0185 1.00689C14.6875 0.982106 14.3549 1.02434 14.0407 1.13106C13.7264 1.23778 13.4369 1.40679 13.1894 1.62799C12.4204 2.66519 12.0018 3.92035 11.9942 5.21149H11.6442C11.6367 3.92036 11.2182 2.66518 10.4492 1.62799C10.0741 1.29876 9.60977 1.08816 9.11496 1.02283C8.62015 0.957497 8.11708 1.04037 7.66937 1.26096C7.22166 1.48155 6.84943 1.82995 6.59973 2.2621C6.35004 2.69425 6.23411 3.19075 6.2666 3.68879C6.30572 4.25624 6.53739 4.79333 6.9233 5.21119H1.4687C1.34439 5.21124 1.22519 5.26066 1.1373 5.34856C1.04941 5.43647 1.00003 5.55568 1 5.67999V9.11879C1.00003 9.24309 1.04942 9.36229 1.13731 9.45018C1.2252 9.53807 1.3444 9.58746 1.4687 9.58749H2.0742V20.8922C2.07478 21.3582 2.26017 21.805 2.58969 22.1345C2.91922 22.464 3.36598 22.6494 3.832 22.65H19.8164C20.2825 22.6496 20.7294 22.4643 21.0589 22.1347C21.3885 21.8052 21.5738 21.3583 21.5742 20.8922V9.58699H22.1797C22.304 9.58696 22.4232 9.53757 22.5111 9.44968C22.599 9.36179 22.6484 9.24259 22.6484 9.11829V5.68029C22.6484 5.55598 22.599 5.43677 22.5111 5.34886C22.4232 5.26096 22.304 5.21154 22.1797 5.21149ZM13.8086 2.33259C14.1248 2.05508 14.5382 1.91454 14.958 1.94188C15.3778 1.96923 15.7696 2.16221 16.0471 2.47839C16.3246 2.79457 16.4652 3.20804 16.4378 3.62784C16.4105 4.04764 16.2175 4.43938 15.9013 4.71689C15.2905 5.05526 14.6009 5.2259 13.9028 5.21149H12.9312C12.9562 4.18988 13.2595 3.19447 13.8086 2.33259ZM7.7386 4.71689C7.42593 4.4385 7.23603 4.04776 7.2103 3.62991C7.18457 3.21205 7.32512 2.80097 7.60127 2.48633C7.87743 2.17168 8.2668 1.97899 8.68446 1.95029C9.10212 1.92158 9.51419 2.05919 9.8308 2.33309C10.3796 3.19488 10.6828 4.1901 10.7077 5.21149H9.746C9.04495 5.22716 8.35211 5.05648 7.7386 4.71689ZM20.6367 20.8922C20.6363 21.1095 20.5498 21.3179 20.3961 21.4716C20.2424 21.6253 20.0341 21.7118 19.8167 21.7122H3.832C3.61464 21.7118 3.4063 21.6253 3.25261 21.4716C3.09892 21.3179 3.0124 21.1095 3.012 20.8922V9.58699H20.637L20.6367 20.8922ZM21.7109 8.64949H1.9375V6.14879H9.543C9.7652 6.16789 9.9846 6.18059 10.1904 6.18059C10.3757 6.18034 10.5609 6.16972 10.7451 6.14879H12.8932C13.0771 6.16972 13.2621 6.18033 13.4472 6.18059C13.6531 6.18059 13.8727 6.16789 14.095 6.14879H21.7109V8.64949Z M15.455 19.3424C15.1472 19.3422 14.8449 19.2604 14.579 19.1051C14.3792 18.9897 14.204 18.836 14.0635 18.6529C13.923 18.4698 13.82 18.2608 13.7602 18.0378C13.7005 17.8149 13.6853 17.5824 13.7154 17.3535C13.7456 17.1247 13.8205 16.9041 13.9359 16.7042C14.0513 16.5043 14.205 16.3291 14.3881 16.1887C14.5712 16.0482 14.7802 15.9451 15.0032 15.8854C15.2261 15.8257 15.4587 15.8105 15.6875 15.8406C15.9163 15.8708 16.137 15.9457 16.3368 16.0611C16.6379 16.235 16.8808 16.4942 17.0346 16.806C17.1883 17.1179 17.2462 17.4683 17.2009 17.813C17.1555 18.1578 17.0089 18.4813 16.7797 18.7427C16.5505 19.0042 16.2489 19.1918 15.913 19.2818C15.7636 19.3216 15.6097 19.342 15.455 19.3424ZM15.4589 16.7633C15.2784 16.7631 15.1028 16.8225 14.9595 16.9323C14.8161 17.0421 14.713 17.1961 14.6662 17.3705C14.6193 17.5449 14.6313 17.7299 14.7003 17.8967C14.7693 18.0636 14.8915 18.203 15.0478 18.2933C15.1408 18.3478 15.2437 18.3832 15.3505 18.3972C15.4574 18.4113 15.5659 18.4039 15.6698 18.3753C15.8267 18.3336 15.9677 18.2463 16.0748 18.1245C16.182 18.0026 16.2506 17.8516 16.2718 17.6907C16.293 17.5298 16.266 17.3662 16.1941 17.2207C16.1223 17.0751 16.0088 16.9542 15.8681 16.8733C15.7439 16.801 15.6027 16.763 15.4589 16.7633ZM10.3783 19.1139C10.2961 19.1139 10.2152 19.0923 10.144 19.0511C10.0727 19.01 10.0136 18.9508 9.9725 18.8795C9.93141 18.8082 9.90982 18.7273 9.90991 18.6451C9.91001 18.5628 9.93178 18.482 9.97303 18.4108L13.432 12.4195C13.4628 12.3662 13.5038 12.3195 13.5526 12.282C13.6015 12.2445 13.6572 12.217 13.7167 12.2011C13.7762 12.1851 13.8382 12.1811 13.8992 12.1891C13.9603 12.1971 14.0191 12.2171 14.0724 12.2479C14.1257 12.2787 14.1725 12.3197 14.21 12.3685C14.2474 12.4174 14.2749 12.4731 14.2909 12.5326C14.3068 12.592 14.3109 12.6541 14.3028 12.7151C14.2948 12.7761 14.2748 12.835 14.244 12.8883L10.7846 18.8795C10.7435 18.9509 10.6843 19.0101 10.613 19.0513C10.5416 19.0925 10.4607 19.1141 10.3783 19.1139ZM8.75623 15.4752C8.4866 15.4749 8.22067 15.4125 7.97897 15.293C7.73728 15.1735 7.52631 15 7.36237 14.786C7.19843 14.5719 7.08592 14.323 7.03352 14.0585C6.98113 13.794 6.99025 13.521 7.0602 13.2606C7.13015 13.0002 7.25904 12.7594 7.43692 12.5568C7.61479 12.3542 7.83688 12.1951 8.08602 12.092C8.33515 11.9889 8.60466 11.9445 8.87371 11.9622C9.14275 11.9799 9.40413 12.0592 9.63763 12.194C9.9388 12.3678 10.1817 12.627 10.3355 12.9388C10.4894 13.2506 10.5473 13.601 10.502 13.9458C10.4567 14.2905 10.3102 14.6141 10.081 14.8756C9.85177 15.137 9.55017 15.3246 9.21433 15.4147C9.06488 15.4545 8.9109 15.4749 8.75623 15.4752ZM8.76023 12.8952C8.68818 12.8954 8.61646 12.905 8.54683 12.9235C8.39028 12.9657 8.24975 13.0534 8.14294 13.1754C8.03614 13.2974 7.96786 13.4483 7.9467 13.609C7.92554 13.7698 7.95246 13.9332 8.02406 14.0787C8.09567 14.2242 8.20874 14.3452 8.34903 14.4265C8.44191 14.4815 8.54495 14.5171 8.65195 14.5311C8.75895 14.5452 8.86769 14.5375 8.97163 14.5085C9.12823 14.4665 9.26887 14.3791 9.37578 14.2572C9.4827 14.1353 9.55108 13.9845 9.57229 13.8237C9.5935 13.663 9.56659 13.4996 9.49496 13.3542C9.42332 13.2087 9.31018 13.0878 9.16983 13.0066C9.04567 12.934 8.90404 12.8957 8.76023 12.8952Z",
      },
      events: {
        icon_path:
          "M3 2.98103H21.6286V18.8988C21.6286 21.1637 19.7925 22.9999 17.5275 22.9999H3V2.98103ZM4.25118 4.23221V21.7487H17.5275C19.1015 21.7487 20.3774 20.4727 20.3774 18.8988V4.23221H4.25118Z M12.3142 9.99179L13.6902 12.3998L16.4057 12.9644L14.5406 15.0173L14.8428 17.7741L12.3142 16.6347L9.78552 17.7741L10.0877 15.0172L8.22273 12.9644L10.9381 12.3998L12.3142 9.99179ZM12.3142 12.5136L11.7448 13.51L10.6211 13.7436L11.3929 14.5932L11.2678 15.7338L12.3142 15.2623L13.3605 15.7338L13.2355 14.5932L14.0073 13.7436L12.8836 13.51L12.3142 12.5136Z M6.47532 3.60662V1H7.7265V3.60662H6.47532Z M11.6887 3.60662V1H12.9399V3.60662H11.6887Z M16.9019 3.60662V1H18.1531V3.60662H16.9019Z M3.62559 6.45652H21.003V7.70769H3.62559V6.45652Z M21.6285 17.1612C21.6285 18.4663 20.5703 19.5245 19.2651 19.5245H18.153V20.6367C18.153 21.9418 17.0948 23 15.7897 23V21.7488C16.4038 21.7488 16.9018 21.2508 16.9018 20.6367V18.2733H19.2651C19.8793 18.2733 20.3773 17.7753 20.3773 17.1612H21.6285Z",
      },
    },
    search: {
      icon_path:
        "M19.8374 21.4724L12.5119 14.1415C11.9305 14.6069 11.2619 14.9754 10.5061 15.2469C9.75025 15.5184 8.94598 15.6542 8.09329 15.6542C5.98088 15.6542 4.1931 14.9221 2.72991 13.4579C1.26674 11.9936 0.535155 10.2045 0.535155 8.09057C0.535155 5.97665 1.26674 4.18755 2.72991 2.72331C4.1931 1.25907 5.98088 0.526947 8.09329 0.526947C10.2057 0.526947 11.9935 1.25907 13.4566 2.72331C14.9198 4.18755 15.6514 5.97665 15.6514 8.09057C15.6514 8.94391 15.5157 9.74875 15.2444 10.5051C14.9731 11.2615 14.6049 11.9306 14.1398 12.5124L21.4653 19.8433L19.8374 21.4724ZM8.09329 13.3269C9.54675 13.3269 10.7822 12.8179 11.7997 11.7997C12.8171 10.7815 13.3258 9.54511 13.3258 8.09057C13.3258 6.63603 12.8171 5.39967 11.7997 4.38149C10.7822 3.36331 9.54675 2.85423 8.09329 2.85423C6.6398 2.85423 5.40433 3.36331 4.3869 4.38149C3.36944 5.39967 2.86074 6.63603 2.86074 8.09057C2.86074 9.54511 3.36944 10.7815 4.3869 11.7997C5.40433 12.8179 6.6398 13.3269 8.09329 13.3269Z",
    },
    venueFilter: {
      all: {
        mime: "image/svg",
        url: "https://s3.venue.in.th/One_siam_logo_d56dd61fec.svg",
        width: 52,
        height: 32,
      },
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: theme.palette.background.default,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
        sizeMedium: {
          height: "40px",
        },
        outlinedPrimary: {},
        containedPrimary: {},
        startIcon: {
          marginRight: theme.spacing(0.5),
          "&.MuiButton-iconSizeMedium .MuiSvgIcon-root": {
            width: "16px",
            height: "16px",
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          height: "16px",
        },
        switchBase: {
          marginTop: theme.spacing(0.25),
          "&.Mui-checked": {
            transform: "translateX(6px)",
            "& + .MuiSwitch-track": {
              backgroundColor: "#5BB600",
            },
          },
        },
        thumb: {
          width: "12px",
          height: "12px",
          marginLeft: theme.spacing(-1),
        },
        track: {
          width: "24px",
          height: "16px",
          backgroundColor: theme.palette.grey[300],
          opacity: 1,
          transition: theme.transitions.create(["background-color"], {
            duration: 500,
          }),
        },
      },
    },
    LoadingScreen: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.default,
        },
      },
    },
    AppCategoryFilterChip: {
      styleOverrides: {
        label: {
          padding: 0,
        },
        root: {
          background: theme.palette.background.paper,
          borderRadius: "4px",
          padding: theme.spacing(1),
          border: `none`,
          "&.MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderRadius: "4px",
          },
          "&.MuiToggleButtonGroup-grouped:not(:first-of-type)": {
            border: `none`,
            borderRadius: "4px",
          },
          "&:hover": {
            background: theme.palette.primary.main,
          },
        },
      },
    },
    AppMapPageLayout: {
      styleOverrides: {
        root: {},
        headerWrapper: {},
      },
    },
    AppPageLayout: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          position: "relative",
          paddingBottom: `${(mixins.bottomNavigation?.height || 75) + 6}px`,
          minHeight: `calc(100% - ${mixins.bottomNavigation?.height || 75}px)`,
          backgroundColor: theme.palette.background.default,
          "@media (max-height: 667px)": {
            paddingBottom: `${(mixins.bottomNavigation?.height || 75) - 12}px`,
          },
        },
        container: {
          padding: theme.spacing(2),
          flexGrow: 1,
          position: "relative",
        },
        headerWrapper: {
          fontSize: "1.125rem",
        },
        navBuffer: {
          height: 0,
        },
      },
    },
    AppDining: {
      styleOverrides: {
        root: {
          paddingBottom: theme.spacing(6),
        },
        filterSection: {
          margin: theme.spacing(0, -2),
        },
        filterContainer: {
          paddingLeft: 0,
          paddingBottom: theme.spacing(2),
        },
        filterButton: {
          gap: theme.spacing(1),
          padding: 0,
          "& .MuiToggleButton-root": {
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: theme.spacing(2),
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: theme.spacing(2),
          },
          "& .allFilter-button": {
            textTransform: "uppercase",
          },
          whiteSpace: "nowrap",
          "& .MuiSvgIcon-root": {
            marginRight: theme.spacing(1),
          },
        },
        gridContainer: {
          display: "grid",
          gridAutoFlow: "row",
          gridTemplateColumns: "repeat(2, 1fr)",
          justifyItems: "center",
          justifyContent: "center",
          gap: theme.spacing(1),
          [theme.breakpoints.up("md")]: {
            gridTemplateColumns: "repeat(4, 1fr)",
          },
        },
        gridItem: {
          width: "100%",
        },
        diningImageCard: {
          display: "block",
          overflow: "hidden",
          aspectRatio: "1 / 1",
          width: "100%",
          height: "100%",
          "& .MuiCardActionArea-root": {
            width: "100%",
            height: "100%",
          },
          "& .MuiCardMedia-img": {
            width: "100%",
            height: "100%",
          },
          "& .MuiCardHeader-root": {
            paddingBottom: theme.spacing(1),
          },
          "& .MuiCardHeader-root .MuiCardHeader-title": {
            lineHeight: 1.3,
          },
          "& .MuiCardHeader-content": {
            overflow: "hidden",
          },
          "& .MuiCardHeader-title": {
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginBottom: theme.spacing(0.1875),
          },
        },
        diningAvatar: {
          width: "50px",
          height: "50px",
        },
        diningAvatarFallBack: {},
        emptyDataContainer: {
          height: `calc(100vh - ${mixins.mobileHeader?.height}px - ${
            mixins.bottomNavigation?.height + 30
          }px - 72px)`,
          // Prevent content page overlap with footer shadow by adding a bottom space (30px)
          //72 px is container padding
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        venueSelector: {
          position: "fixed",
          bottom: mixins.bottomNavigation?.height + 45,
          right: "24px",
          zIndex: 1, // Prevents restaurants' info from appearing on top
        },
        subCategoryFilterBar: {
          gap: theme.spacing(2),
          padding: 0,
          "& .MuiToggleButton-root": {
            borderRadius: "9999px",
            padding: theme.spacing(1.5),
            height: "unset",
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiButtonBase-root.MuiToggleButtonGroup-grouped:first-of-type": {
            borderRadius: "9999px",
            marginLeft: theme.spacing(2),
          },
          "& .MuiButtonBase-root.MuiToggleButtonGroup-grouped:last-of-type": {
            marginRight: theme.spacing(2),
          },
          "& .MuiButtonBase-root.MuiToggleButtonGroup-grouped:not(:first-of-type)":
            {
              borderRadius: "9999px",
            },
        },
        scrollPane: {
          padding: 0,
          "& .MuiToggleButtonGroup-root": {
            gap: theme.spacing(1),
          },
          "& .MuiDivider-root": {
            borderBottomWidth: 8,
          },
        },
        buildingWithLevelFilterSection: {
          display: "none",
          gap: theme.spacing(2),
          padding: theme.spacing(0, 3),
          "& .MuiToggleButtonGroup-root": {
            gap: theme.spacing(1),
          },
          "& .MuiDivider-root": {
            borderBottomWidth: 8,
          },
        },
        buildingFilterSelect: {
          flex: "5 0 0",
        },
        levelFilterSelect: {
          flex: "4 0 0",
        },
        selectMenuItem: {
          fontSize: "0.75rem",
        },
        resetButton: {
          color: theme.palette.info.main,
          textDecoration: "underline",
          fontSize: "0.75rem",
        },
        divider: {
          borderBottomWidth: "0.5px",
          background: theme.palette.grey[500],
        },
        list: {
          padding: theme.spacing(0, 1),
          paddingTop: theme.spacing(1),
        },
        emptyDataWrapper: {
          marginTop: theme.spacing(3),
        },
        headerWrapper: {},
        navigationWrapper: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
    },
    ServicePage: {
      styleOverrides: {
        root: {},
        gridContainer: {
          display: "grid",
          gridAutoFlow: "row",
          gridTemplateColumns: "repeat(1, 1fr)",
          justifyItems: "center",
          justifyContent: "center",
          gap: theme.spacing(1),
        },
        gridItem: {
          width: "100%",
        },
        emptyDataContainer: {
          height: `calc(100vh - ${mixins.mobileHeader?.height}px - ${
            mixins.bottomNavigation?.height + 30
          }px)`,
          // Prevent content page overlap with footer shadow by adding a bottom space (30px)
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        headerWrapper: {},
        navigationWrapper: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
    },
    DirectoryPage: {
      styleOverrides: {
        root: {
          margin: 0,
          paddingBottom: theme.spacing(7),
          "& .MuiList-root": {},
        },
        filterSection: {
          position: "sticky",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
          top: 0,
          zIndex: 1,
          margin: theme.spacing(-2, -2, 0, -2),
          paddingTop: theme.spacing(2),
          background: theme.palette.background.paper,
          paddingBottom: theme.spacing(2),
        },
        categoryFilterBar: {
          gap: theme.spacing(1),
          padding: 0,
          "& .MuiToggleButton-root": {
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: theme.spacing(2),
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: theme.spacing(2),
          },
          "& .allFilter-button": {
            textTransform: "uppercase",
          },
          whiteSpace: "nowrap",
          "& .MuiSvgIcon-root": {
            marginRight: theme.spacing(1),
          },
        },
        headerWrapper: {},
        navigationWrapper: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
        },
        list: {
          padding: 0,
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(0.5),
          paddingTop: 0,
        },
      },
    },
    PromotionPage: {
      styleOverrides: {
        root: {},
        headerWrapper: {},
        navigationWrapper: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
        },
        emptyDataContainer: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 0,
          paddingBottom: 0,
          height: "380px",
          position: "relative",
        },
        carouselContainer: {
          marginTop: theme.spacing(2),
        },
        promotionImage: {},
        promotionCarousel: {
          "& .splide": {},
          "& .splide__pagination": {
            marginTop: theme.spacing(0.5),
            padding: theme.spacing(1),
          },
          "& .splide__pagination__page": {
            width: "4px",
            height: "4px",
            backgroundColor: theme.palette.grey[200],
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.primary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut}`,
            transform: "none",
            width: "8px",
            borderRadius: "16px",
          },
          "& .splide__track": {
            padding: 0,
            margin: theme.spacing(0, -2),
            "&:last-child": {
              /**
               * Keep spacing when Splide.js hides the pagination due to having enough space for all slides.
               * [ref] https://splidejs.com/guides/overflow/
               */
              paddingBottom: theme.spacing(4.5),
            },
          },
          "& .splide__slide": {
            "&> *": {
              display: "inline-block",
              opacity: 0.4,
              transition: `all ${theme.transitions.duration.short}ms cubic-bezier(0.65, 0, 0.35, 1)`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
              },
            },
          },
        },
        promotionCarouselItem: {},
        promotionGroupSelectorButton: {
          display: "flex",
          justifyContent: "center",
          gap: 3,
          "& .MuiToggleButton-root": {
            width: "132px",
            height: "33px",
            color: theme.palette.text.primary,
            "&.Mui-selected": {
              color: theme.palette.primary.contrastText,
            },
          },
        },
        toggleButtonGroup: {
          background: theme.palette.background.paper,
          boxShadow: "0px 4px 24px 0px #0000000D",
          padding: theme.spacing(0.5, 1),
          borderRadius: "64px",
          width: "288px",
          "& .MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderRadius: "64px",
            border: "none",
          },
          "& .MuiToggleButtonGroup-grouped:last-of-type": {
            borderRadius: "64px",
            border: "none",
          },
          "& .MuiToggleButton-root": {
            borderRadius: "64px",
            height: "33px",
            fontSize: "0.875rem",
            textTransform: "uppercase",
            fontWeight: 400,
            padding: theme.spacing(1, 2),
          },
        },
      },
    },
    CarouselImageCard: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
        imageWrapper: {
          position: "relative",
          overflow: "hidden",
          aspectRatio: "9/16",
          height: "min(68vh, 612px)",
          borderRadius: "inherit",
          "@media (max-height: 667px)": {
            height: "min(60vh, 400px)",
          },
          [theme.breakpoints.up("md")]: {
            height: "min(60vh, 900px)",
          },
        },
        image: {
          objectFit: "cover",
          height: "100%",
          width: "100%",
          display: "block",
          boxShadow: "none",
          cursor: "pointer",
        },
        highlightBanner: {
          position: "absolute",
          top: 0,
          right: 0,
          "& .MuiSvgIcon-root": {
            position: "relative",
            zIndex: 1,
            fill: theme.palette.primary.contrastText,
            height: "16px",
            width: "16px",
            top: theme.spacing(0.625), // 5px
            right: theme.spacing(0.5), // 4px
          },
          "&:after": {
            content: "''",
            position: "absolute",
            background: theme.palette.primary.main,
            width: "60px",
            height: "60px",
            top: theme.spacing(-3.75), // -30px
            right: theme.spacing(-3.75), // -30px
            transform: "rotate(45deg)",
          },
        },
      },
    },
    PromotionDetailPage: {
      styleOverrides: {
        headerWrapper: {},
        navigationWrapper: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
        },
        button: {
          flexGrow: 1,
        },
        buttonContainer: {
          backgroundColor: theme.palette.background.paper,
          display: "flex",
          padding: theme.spacing(1, 2),
          gap: theme.spacing(1),
        },
        contentSecondaryText: {},
        contentTextWrapper: {},
        coverBanner: {
          position: "absolute",
          height: "min(16vh, 245px)",
          top: 0,
          left: 0,
          right: 0,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundColor: "#F6F6F6E5",
          backgroundBlendMode: "lighten",
        },
        contentWrapper: { position: "relative" },
        detailContent: {},
        detailWrapper: { padding: theme.spacing(2, 0) },
        divider: {
          width: "20%",
          margin: theme.spacing(3, "auto"),
          borderColor: theme.palette.primary.main,
        },
        image: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "4px",
        },
        imageWrapper: {
          aspectRatio: "9 / 16",
          height: "min(45vh, 700px)",
          margin: "0 auto",
        },
        infoContainer: {
          display: "flex",
          gap: theme.spacing(3),
          justifyContent: "center",
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: theme.spacing(1.5),
        },
        infoListItem: {
          width: "fit-content",
          "& .MuiListItemText-root .MuiTypography-root": {
            fontSize: "0.875rem",
            color: theme.palette.text.primary,
          },
          "& .MuiAvatar-root": {
            width: "16px",
            height: "16px",
            background: "unset",
            borderRadius: 0,
            "& .MuiSvgIcon-root": {
              width: "inherit",
              height: "inherit",
              color: theme.palette.text.primary,
              "& .highlight": {
                fill: theme.palette.primary.main,
              },
            },
          },
          "& .MuiListItemAvatar-root": {
            minWidth: "unset",
            marginRight: theme.spacing(1),
          },
        },
        linkButton: {
          minWidth: "unset",
          padding: theme.spacing(1),
          "& .MuiButton-startIcon": {
            marginLeft: 0,
            marginRight: 0,
          },
        },
        pageWrapper: {
          paddingBottom: theme.spacing(6),
        },
        title: {
          textAlign: "center",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          fontSize: "1.125rem",
        },
      },
    },
    EventPage: {
      styleOverrides: {
        root: {},
        headerWrapper: {},
        navigationWrapper: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
        },
        emptyDataWrapper: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 0,
          paddingBottom: 0,
          height: "380px",
          position: "relative",
        },
        eventGroupSelectorButton: {
          display: "flex",
          justifyContent: "center",
          gap: 3,
          "& .MuiToggleButton-root": {
            width: "132px",
            height: "33px",
            color: theme.palette.text.primary,
            "&.Mui-selected": {
              color: theme.palette.primary.contrastText,
            },
          },
        },
        toggleButtonGroup: {
          background: theme.palette.background.paper,
          boxShadow: "0px 4px 24px 0px #0000000D",
          padding: theme.spacing(0.5, 1),
          borderRadius: "64px",
          width: "288px",
          "& .MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderRadius: "64px",
            border: "none",
          },
          "& .MuiToggleButtonGroup-grouped:last-of-type": {
            borderRadius: "64px",
            border: "none",
          },
          "& .MuiToggleButton-root": {
            borderRadius: "64px",
            height: "33px",
            fontSize: "0.875rem",
            textTransform: "uppercase",
            fontWeight: 400,
            padding: theme.spacing(1, 2),
          },
        },
        carouselContainer: {
          marginTop: theme.spacing(2),
        },
        eventImage: {},
        eventCarousel: {
          "& .splide": {},
          "& .splide__pagination": {
            marginTop: theme.spacing(0.5),
            padding: theme.spacing(1),
          },
          "& .splide__pagination__page": {
            width: "4px",
            height: "4px",
            backgroundColor: theme.palette.grey[200],
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.primary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut}`,
            transform: "none",
            width: "8px",
            borderRadius: "16px",
          },
          "& .splide__track": {
            padding: 0,
            margin: theme.spacing(0, -2),
            "&:last-child": {
              /**
               * Keep spacing when Splide.js hides the pagination due to having enough space for all slides.
               * [ref] https://splidejs.com/guides/overflow/
               */
              paddingBottom: theme.spacing(4.5),
            },
          },
          "& .splide__slide": {
            "&> *": {
              display: "inline-block",
              opacity: 0.4,
              transition: `all ${theme.transitions.duration.short}ms cubic-bezier(0.65, 0, 0.35, 1)`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
              },
            },
          },
        },
        eventCarouselItem: {},
      },
    },
    EventDetailPage: {
      styleOverrides: {
        headerWrapper: {},
        navigationWrapper: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
        },
        button: {
          flexGrow: 1,
        },
        buttonContainer: {
          backgroundColor: theme.palette.background.paper,
          display: "flex",
          padding: theme.spacing(1, 2),
          gap: theme.spacing(1),
        },
        contentSecondaryText: {},
        contentTextWrapper: {},
        coverBanner: {
          position: "absolute",
          height: "min(16vh, 245px)",
          top: 0,
          left: 0,
          right: 0,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundColor: "#F6F6F6E5",
          backgroundBlendMode: "lighten",
        },
        contentWrapper: { position: "relative" },
        detailContent: {},
        detailWrapper: { padding: theme.spacing(2, 0) },
        divider: {
          width: "20%",
          margin: theme.spacing(3, "auto"),
          borderColor: theme.palette.primary.main,
        },
        image: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "4px",
        },
        imageWrapper: {
          aspectRatio: "9 / 16",
          height: "min(45vh, 700px)",
          margin: "0 auto",
        },
        infoContainer: {
          display: "flex",
          gap: theme.spacing(3),
          justifyContent: "center",
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: theme.spacing(1.5),
        },
        infoListItem: {
          width: "fit-content",
          "& .MuiListItemText-root .MuiTypography-root": {
            fontSize: "0.875rem",
            color: theme.palette.text.primary,
          },
          "& .MuiAvatar-root": {
            width: "16px",
            height: "16px",
            background: "unset",
            borderRadius: 0,
            "& .MuiSvgIcon-root": {
              width: "inherit",
              height: "inherit",
              color: theme.palette.text.primary,
              "& .highlight": {
                fill: theme.palette.primary.main,
              },
            },
          },
          "& .MuiListItemAvatar-root": {
            minWidth: "unset",
            marginRight: theme.spacing(1),
          },
        },
        linkButton: {
          minWidth: "unset",
          padding: theme.spacing(1),
          "& .MuiButton-startIcon": {
            marginLeft: 0,
            marginRight: 0,
          },
        },
        pageWrapper: {
          paddingBottom: theme.spacing(6),
        },
        title: {
          textAlign: "center",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          fontSize: "1.125rem",
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 1, 1),
          "&.Mui-selected": {
            "&:after": {
              display: "none",
            },
          },
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          width: "100%",
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[10],
          height: mixins.bottomNavigation?.height,
          padding: theme.spacing(0, 6.75),
          gap: 10,
          [theme.breakpoints.up("sm")]: {
            width: "auto",
            gap: 40,
            borderRadius: 0,
          },
        },
      },
    },
    AppMap: {
      styleOverrides: {
        indoorMapContainer: {
          backgroundColor: theme.palette.common.white,
          "&.bottom-half": {
            "& .maptalks-wrapper": {
              transform: `none`,
            },
          },
        },
        mainMenuContainer: {},
        footerActionContainer: {},
        headerWrapper: {},
        ordinalSelectMenu: {
          zIndex: theme.zIndex.appBar + 1,
          bottom: "150px",
          right: "16px",
        },
        navigationWrapper: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
          ":after": BOTTOM_GREDIENT_MAP_PAGE_EFFECT,
          "& .MuiBottomNavigation-root": {
            boxShadow: "none",
          },
        },
      },
    },
    AppCategoryFilterButton: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
          padding: theme.spacing(1),
          justifyContent: "center",
          width: "max-content",
          "&.Mui-selected": {
            "& .MuiTypography-root": {},
          },
          "&:hover": {},
          "&.Mui-selected, &.Mui-selected:hover": {},
        },
        label: {
          fontSize: "0.875rem",
          lineHeight: 1.5,
        },
        icon: {
          display: "none",
        },
      },
    },
    SearchContainer: {
      styleOverrides: {
        dialog: {},
        root: {
          height: "100%",
          paddingBottom: theme.spacing(12),
        },
        listContainer: {
          padding: 0,
        },
        toolbarContainer: {
          display: "flex",
          flexDirection: "column",
          position: "sticky",
          top: 0,
          zIndex: 1,
          backgroundColor: theme.palette.background.paper,
          marginTop: theme.spacing(-2),
          paddingTop: theme.spacing(2),
        },
        categoryFilterBarContainer: {
          width: "100%",
          padding: theme.spacing(1, 0),
          "&:after": {
            background: `linear-gradient(90deg, rgba(255, 255, 255, 0.00) 10 %, ${theme.palette.background.default} 90 %)`,
          },
          "&:before": {
            background: `linear-gradient(90deg, ${theme.palette.background.default} 10 %, rgba(255, 255, 255, 0.00) 90 %)`,
          },
        },
        categoryFilterBar: {
          position: "relative",
          "&:after": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
            zIndex: 1,
            position: "absolute",
            right: "-4px",
            top: 0,
            bottom: 0,
          },
          "&:before": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, #fff 10%, rgba(255, 255, 255, 0.00) 90%)",
            zIndex: 1,
            position: "absolute",
            left: "-4px",
            top: 0,
            bottom: 0,
          },
        },
        scrollPane: {
          padding: 0,
        },
        categoryFilterButtonGroup: {
          gap: theme.spacing(1),
        },
        categoryFilterButton: {},
        searchBarContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          gap: theme.spacing(3),
          width: "100%",
        },
        venueFilterContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          bottom: 0,
          marginBottom: theme.spacing(4),
        },
        searchInput: {
          border: `1px solid ${theme.palette.primary.main} `,
          borderRadius: "72px",
          padding: theme.spacing(1, 2, 1, 1),
          fontSize: "0.8125rem",
          backgroundColor: theme.palette.common.white,
          color: "#231F20",
          "& .MuiInputAdornment-positionStart": {
            border: `1px solid ${theme.palette.primary.main} `,
            borderRadius: "9999px",
            fontSize: "0.5rem",
            padding: theme.spacing(0.5),
            width: "24px",
            minWidth: "24px",
            minHeight: "24px",
            marginRight: theme.spacing(1),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: theme.palette.primary.main,
            "& .MuiSvgIcon-root": {
              width: "10px",
              height: "10px",
            },
          },
          "& .MuiInputAdornment-positionEnd": {
            color: "#C7C6C6",
            "& .MuiSvgIcon-root": {
              width: "12px",
              height: "12px",
            },
          },
          "& .MuiInputBase-input": {
            padding: 0,
          },
        },
        headerWrapper: {},
        navigationWrapper: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
    },
    FeatureListItem: {
      styleOverrides: {
        root: {
          position: "relative",
          display: "flex",
          overflow: "hidden",
          flexDirection: "row",
          backgroundColor: theme.palette.background.paper,
          borderRadius: "4px",
          padding: 0,
          "&.siam-paragon .MuiListItemText-secondary": {
            borderColor: "#A3873E",
          },
          "&.siam-discovery .MuiListItemText-secondary": {
            borderColor: "#66676C",
          },
          "&.siam-center .MuiListItemText-secondary": {
            borderColor: "#ECCB20",
          },
          "&.is-highlight": {
            "& .MuiListItemText-primary": {
              color: theme.palette.primary.main,
              fontWeight: 700,
            },
            "& .FeatureListItem-highlightBanner": {
              display: "inline-block",
            },
          },
        },
        adornmentDivider: {
          marginRight: 0,
          borderRight: "none",
        },
        adornmentWrapper: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
          "& img": {
            objectFit: "contain",
            maxWidth: "50px",
            maxHeight: "unset",
            filter: "brightness(0) invert(0.8)",
            marginRight: theme.spacing(2),
          },
        },
        bottomDivider: {
          display: "none",
        },
        listItemText: {
          flex: 2.5,
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          "& .MuiListItemText-primary": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            lineHeight: 1.5,
            fontSize: "0.875rem",
            fontWeight: 400,
            whiteSpace: "normal",
            wordBreak: "break-all",
          },
          "& .MuiListItemText-secondary": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            fontSize: "0.875rem",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            lineHeight: 1,
            paddingLeft: theme.spacing(1),
            color: theme.palette.text.primary,
            borderLeft: `2px solid ${theme.palette.primary.main} `,
          },
        },
        listItemAvatar: {
          "& .MuiAvatar-root": {
            width: "64px",
            height: "64px",
            fontSize: "2.275rem",
            marginRight: theme.spacing(2),
            borderRadius: "4px 0px 0px 4px",
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.text.primary,
            "& .MuiAvatar-img": {
              backgroundColor: theme.palette.common.white,
            },
          },
          "& .MuiSvgIcon-root": {
            fontSize: "inherit",
          },
        },
        listItemContent: {
          display: "flex",
          width: "100%",
          gap: theme.spacing(2),
        },
        boothNameText: {
          display: "none",
        },
        highlightBanner: {
          position: "absolute",
          display: "none",
          top: 0,
          right: 0,
          "& .MuiSvgIcon-root": {
            position: "relative",
            zIndex: 1,
            fill: theme.palette.primary.contrastText,
            height: "10px",
            width: "10px",
            top: theme.spacing(-0.25), // -2px
            right: theme.spacing(0.375), // 3px
          },
          "&:after": {
            content: "''",
            position: "absolute",
            background: theme.palette.primary.main,
            width: "40px",
            height: "40px",
            top: theme.spacing(-2.5), // -20px
            right: theme.spacing(-2.5), // -20px
            transform: "rotate(45deg)",
          },
        },
      },
    },
    FeatureSkeletonListItem: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          backgroundColor: theme.palette.background.paper,
          borderRadius: "4px",
          padding: 0,
        },
        bottomDivider: {
          display: "none",
        },
        listItemTextPrimary: {
          fontSize: "0.875rem",
        },
        listItemTextSecondary: {
          fontSize: "0.875rem",
        },
        listItemAvatar: {},
        avatar: {
          width: "64px",
          height: "64px",
          marginRight: theme.spacing(2.25),
        },
        listItemContent: {
          display: "flex",
          width: "100%",
          gap: theme.spacing(2),
        },
      },
    },
    FeatureChipToggleBar: {
      styleOverrides: {
        root: {
          margin: "0 auto",
          justifyContent: "center",
          padding: theme.spacing(2),
          gap: theme.spacing(1),
        },
        button: {
          height: "32px",
          width: "32px",
          borderRadius: "9999px",
          backgroundColor: "#231F20B2",
          border: "1px solid #231F20B2",
          "&> .MuiSvgIcon-root": {
            width: "18px",
            height: "18px",
          },
          "&.Mui-selected": {
            background: theme.palette.primary.main,
            "& svg": {
              fill: "#231F20B2",
            },
            ":hover": {
              background: theme.palette.primary.main,
            },
          },
          "&.MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderRadius: "50%",
          },
          "&.MuiToggleButtonGroup-grouped:not(:first-of-type)": {
            border: "1px solid #231F20B2",
            margin: 0,
            borderRadius: "50%",
          },
          "&.MuiToggleButtonGroup-grouped:first-of-type": {
            marginLeft: 0,
          },
          "& svg": {
            margin: 0,
            fill: theme.palette.common.white,
          },
          ":hover": {
            background: theme.palette.primary.main,
            "& svg": {
              fill: "#231F20B2",
            },
          },
        },
        text: {
          display: "none",
        },
      },
    },
    DirectionSearchContainer: {
      styleOverrides: {
        wrapper: {
          width: "100%",
          [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
          },
        },
        suggestionList: {
          marginTop: theme.spacing(1),
          padding: 0,
          // direction search box = 108 px
          // avoid step button 32 px + top-bottom margin 16px * 2 = 64px
          // top-bottom page layout padding 24px * 2 = 48px
          maxHeight: `calc(100vh - 220px)`,
          overflow: "auto",
          background: theme.palette.background.paper,
          boxShadow: theme.shadows[1],
          position: "absolute",
          zIndex: theme.zIndex.drawer + 1,
          borderRadius: "10px",
          //left-right layout padding = 16 * 2 = 32px
          width: `calc(100vw - 32px)`,
          [theme.breakpoints.up("sm")]: {
            //left-right layout padding = 16 * 2 = 32px
            maxWidth: mixins.mobileDirectionSearch.width - 32,
          },
        },
      },
    },
    VenueSelector: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "center",
          width: "100%",
          gap: theme.spacing(2),
          padding: theme.spacing(1),
          backgroundColor: theme.palette.background.paper,
        },
        buttonWrapper: {
          display: "flex",
          justifyContent: "center",
          transition: `background ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn} `,
          "&.all": { display: "block" },
          "&.siam-paragon": {
            order: 1,
          },
          "&.siam-center": {
            order: 2,
          },
          "&.siam-discovery": {
            order: 3,
          },
          "&.selected": {
            transform: "none",
            marginLeft: 0,
            marginRight: 0,
            "&.all .MuiButtonBase-root": {
              background: "#FF3A75",
            },
            "&.siam-paragon .MuiButtonBase-root": {
              background: "#A3873E",
            },
            "&.siam-center .MuiButtonBase-root": {
              background: "#000",
            },
            "&.siam-discovery .MuiButtonBase-root": {
              background: "#66676C",
            },
          },
        },
        icon: {
          borderRadius: 0,
          "& img": {
            transition: `filter ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn} `,
            objectFit: "contain",
          },
        },
        button: {
          width: "40px",
          height: "40px",
          background: `url(https://s3.venue.in.th/venue_btn_bg_20343fafe1.png)`,
          backgroundSize: "contain",
          backgroundColor: "unset",
          borderRadius: "4px",
          boxShadow: "0px 6px 8px 0px #0000001A",
          padding: theme.spacing(0.7),
          transition: `background ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
          "&.Mui-selected": {
            background: "none",
            ":hover": {
              backgroundColor: "unset",
            },
            "& img": {
              filter: "brightness(0) invert(1)",
            },
          },
        },
        currentVenueChip: {
          display: "none",
        },
      },
    },
    VuiSearchResult: {
      styleOverrides: {
        root: {
          flexGrow: 1,
          width: "100%",
          overflow: "hidden",
        },
        list: {
          display: "flex",
          flexDirection: "column",
          padding: theme.spacing(0),
          gap: theme.spacing(0.5),
        },
        listItem: {
          padding: 0,
        },
      },
    },
    VuiSearchResultItem: {
      defaultProps: {
        secondaryTextKeys: ["floorText"],
      },
      styleOverrides: {
        chip: {
          borderRadius: "4px",
          height: "18px",
          fontWeight: 400,
          backgroundColor: theme.palette.grey[400],
          color: theme.palette.common.white,
          fontSize: "0.625rem",
          "& .MuiChip-label": {
            padding: theme.spacing(0, 1),
          },
        },
        primaryWrapper: {
          display: "flex",
          alignItems: "flex-start",
          gap: theme.spacing(0.5),
        },
        list: {},
        listItem: {},
      },
    },
    SuggestionListItem: {
      defaultProps: {
        secondaryTextKeys: ["floorText"],
      },
      styleOverrides: {
        root: {
          padding: 0,
          borderBottom: "none",
          "& .MuiListItemAvatar-root > .MuiAvatar-root": {
            borderRadius: 0,
          },
        },
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        grouped: {
          "&:not(:last-of-type)": {
            borderRadius: "4px",
          },
          "&:not(:first-of-type)": {
            borderRadius: "4px",
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
        sizeMedium: {
          height: "40px",
        },
      },
    },
    DiningCard: {
      styleOverrides: {
        root: {
          display: "flex",
          height: "158px",
          borderRadius: "4px",
          backgroundColor: theme.palette.background.paper,
          flexDirection: "column",
          boxShadow: "none",
        },
        headerContainer: {
          display: "flex",
          alignItems: "flex-start",
          gap: theme.spacing(2),
        },
        occupantLogo: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "0 0 32px",
          backgroundColor: theme.palette.grey[500],
          borderRadius: "0",
          width: "32px",
          height: "32px",
          "& .MuiSvgIcon-root": {
            width: "16px",
            height: "16px",
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
            backgroundColor: theme.palette.common.white,
          },
        },
        occupantLogoFallback: {
          color: theme.palette.grey[500],
          width: "16px",
          height: "16px",
        },
        featuredImageFallback: {
          width: "50px",
          height: "50px",
        },
        occupantFeaturedImage: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "0 0 80px",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "80px",
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
            backgroundColor: theme.palette.common.white,
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(1),
          height: "100%",
          "& .MuiTypography-root": {
            lineHeight: 1.15,
          },
        },
        levelContainer: {
          display: "inline-flex",
          "& .MuiTypography-root": {
            lineHeight: 1,
            fontWeight: 400,
            paddingLeft: theme.spacing(0.5),
            fontSize: "0.875rem",
            borderLeft: `2px solid ${theme.palette.primary.main}`,
          },
        },
        divider: {
          display: "none",
        },
        venueLogo: {
          width: "50px",
          filter: "brightness(0) invert(0.8)",
        },
        titleText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          wordBreak: "break-word",
          fontSize: "0.875rem",
          lineHeight: 1.5,
        },
        titleContainer: {},
        detailWrapper: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 0,
          alignItems: "center",
        },
      },
    },
    DiningSkeletonCard: {
      styleOverrides: {
        root: {
          display: "flex",
          height: "158px",
          borderRadius: "4px",
          backgroundColor: theme.palette.background.paper,
          flexDirection: "column",
          boxShadow: "none",
        },
        avatar: {
          boxShadow: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "0",
          width: "100%",
          height: "80px",
          flex: "0 0 80px",
        },
        logo: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "0 0 32px",
          borderRadius: "0",
          width: "32px",
          height: "32px",
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(1),
          height: "100%",
        },
        headerContainer: {
          display: "flex",
          alignItems: "flex-start",
          gap: theme.spacing(2),
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 0,
          alignItems: "center",
        },
        venueLogo: {
          height: "26px",
          width: "86px",
        },
        primaryText: {
          fontSize: "0.875rem",
        },
        secondaryText: {
          fontSize: "0.875rem",
        },
      },
    },
    AppNavigation: {
      styleOverrides: {
        root: {},
        menuButton: {
          borderRadius: "8px",
          display: "flex",
          flex: "0 0 66px",
          height: "54px",
          minWidth: "unset",
          maxWidth: "unset",
          padding: theme.spacing(1, 0),
          "&>.MuiSvgIcon-root": {
            width: "16px",
            height: "16px",
            marginBottom: theme.spacing(1),
          },
          "&:not(.Mui-selected)": {
            "& .MuiSvgIcon-root .highlight": {
              fill: theme.palette.primary.main,
            },
          },
          "&.Mui-selected": {
            "& .MuiNavigationLink-backside": {
              display: "flex",
            },
          },
          "& .MuiNavigationLink-backside": {
            alignItems: "center",
            justifyContent: "center",
            "& .MuiSvgIcon-root": {
              marginBottom: 0,
              width: "40px",
              height: "40px",
              opacity: 0.1,
            },
          },
          "& .MuiBottomNavigationAction-label, .MuiBottomNavigationAction-label.Mui-selected":
            {
              fontSize: "0.625rem",
              textTransform: "uppercase",
            },
        },
        navigationContainer: {
          maxWidth: "unset",
          marginBottom: 0,
          padding: theme.spacing(2),
          height: mixins.bottomNavigation.height,
          borderRadius: "0px",
          gap: theme.spacing(1),
        },
      },
    },
    AppHeader: {
      styleOverrides: {
        root: {
          position: "relative",
          backgroundColor: theme.palette.grey[50],
          boxShadow: "none",
          width: "100%",
          color: theme.palette.text.primary,
          fontWeight: 600,
          textAlign: "center",
        },
        toolbar: {
          minHeight: mixins.mobileHeader.height,
          justifyContent: "space-between",
          alignItems: "center",
          padding: theme.spacing(0, 2),
          width: `100%`,
          [theme.breakpoints.up("md")]: {
            margin: `0 auto`,
            maxWidth: 900,
          },
        },
        logoContainer: {
          display: "inline-flex",
          margin: "0 auto",
          "&>img": {
            maxWidth: "66px",
          },
        },
        titleContainer: {
          width: "100%",
          fontWeight: "400",
        },
        backButtonContainer: {
          position: "absolute",
          left: theme.spacing(1.25),
          minWidth: "48px",
        },
        menuButtonContainer: {
          position: "absolute",
          left: theme.spacing(1.25),
          minWidth: "48px",
        },
        searchButtonContainer: {
          position: "absolute",
          right: 0,
          minWidth: "48px",
        },
      },
    },
    AppHeaderBackButton: {
      styleOverrides: {
        root: { marginRight: theme.spacing(2) },
        icon: {
          width: 20,
          height: 20,
        },
      },
    },
    AppHeaderMenuButton: {
      styleOverrides: {},
    },
    HomePage: {
      styleOverrides: {
        root: {},
        contentContainer: {
          display: "flex",
          flexDirection: "column",
        },
        featureCarouselWrapper: {
          padding: theme.spacing(2, 2, 3, 2),
        },
        carousel: {
          "& .splide": {},
          "& .splide__pagination": {
            marginTop: theme.spacing(3),
            padding: theme.spacing(1),
          },
          "& .splide__pagination__page": {
            width: "4px",
            height: "4px",
            backgroundColor: theme.palette.grey[200],
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.primary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut}`,
            transform: "none",
            width: "8px",
            borderRadius: "16px",
          },
          "& .splide__track": {
            padding: 0,
            "&:last-child": {
              /**
               * Keep spacing when Splide.js hides the pagination due to having enough space for all slides.
               * [ref] https://splidejs.com/guides/overflow/
               */
              paddingBottom: theme.spacing(7),
            },
          },
        },
        carouselItem: {},
      },
    },
    HeaderSearchButton: {
      styleOverrides: {},
    },
    BorderLinearProgress: {
      styleOverrides: {
        root: {
          position: "relative",
          width: "100%",
          "&:after": {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            content: "''",
            display: "block",
            height: 2,
            width: "100%",
            borderRadius: "9999px",
            backgroundColor: theme.palette.grey[300],
            right: 0,
          },
        },
        linearProgress: {
          height: 2,
          borderRadius: "9999px",
          zIndex: 1,
          ":after": {
            position: "absolute",
            zIndex: 5,
            top: "50%",
            transform: "translateY(-50%)",
            height: 2,
            content: "''",
            display: "block",
          },
          "&.MuiLinearProgress-colorPrimary": {
            backgroundColor: "transparent",
            "&.Mui-start": {
              ":after": {
                backgroundColor: theme.palette.primary.main,
              },
            },
            ":after": {
              height: 2,
              width: 2,
            },
            "&.Mui-complete": {
              ":before": {
                backgroundColor: theme.palette.primary.main,
              },
              ":after": {
                backgroundColor: theme.palette.primary.main,
              },
            },
            ":before": {
              height: 2,
              width: 2,
            },
          },
          "& .MuiLinearProgress-bar": {
            margin: "auto 0",
            height: 2,
            borderRadius: "9999px",
            backgroundColor: theme.palette.primary.main,
            boxShadow: "none",
          },
        },
      },
    },
    FeatureCard: {
      styleOverrides: {
        root: {
          boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "row",
          height: 118,
          minWidth: "288px",
          padding: theme.spacing(1.5, 2),
          gap: theme.spacing(2),
        },
        cardMedia: {
          width: 53,
          height: 94,
          borderRadius: "4px",
          objectFit: "cover",
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          "&:last-child": {
            padding: 0,
          },
          "& .MuiTypography-root": {
            fontSize: "0.8125rem",
          },
        },
        titleText: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          fontSize: "0.75rem",
          fontWeight: 700,
        },
        infoContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(0.5),
        },
        infoItem: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          color: theme.palette.text.secondary,
          gap: theme.spacing(0.5),
          "& .MuiTypography-root": {
            fontSize: "0.75rem",
            fontWeight: 400,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
          },
        },
        iconWrapper: {
          width: "auto",
          "& .MuiSvgIcon-root": {
            height: "12px",
            width: "12px",
            color: theme.palette.text.primary,
            "& .highlight": {
              fill: theme.palette.primary.main,
            },
          },
        },
      },
    },
    AppFullScreenStart: {
      styleOverrides: {
        root: {
          cursor: "pointer",
          zIndex: -1,
          background: `linear-gradient(180deg, rgba(255, 255, 255, 0.00) 47.76%, #FFF 100%), rgba(35, 31, 32, 0.60)`,
          backdropFilter: "blur(1px)",
        },
        startIconnWrapper: {
          position: "relative",
          width: "88px",
          height: "88px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgb(35 31 32 / 20%)",
          borderRadius: "50%",
          "&:after, :before": {
            opacity: 0,
            display: "flex",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            content: '""',
            height: "100%",
            width: "100%",
            border: `5px solid ${alpha(theme.palette.common.white, 0.4)}`,
            borderRadius: 9999,
            zIndex: -1,
          },
          "&:after": {
            animation: `ripple 3s infinite ${theme.transitions.easing.easeInOut}`,
          },
          "&:before": {
            animation: `ripple 3s infinite ${theme.transitions.easing.easeInOut} 0.5s`,
          },
        },
        actionButtonWrapper: {
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: theme.spacing(2),
          "& .MuiSvgIcon-root": {
            width: "48px",
            height: "48px",
          },
        },
        actionButton: {
          position: "relative",
          fontSize: "1.125rem",
          textTransform: "uppercase",
          color: theme.palette.text.secondary,
          fontWeight: 400,
          borderRadius: 999,
          backgroundColor: alpha(theme.palette.background.paper, 0.6),
          transition: theme.transitions.create("all"),
          padding: theme.spacing(1, 2),
          "&:hover": {
            backgroundColor: alpha(theme.palette.background.paper, 0.6),
          },
          "& .MuiButton-startIcon>svg": {
            fontSize: "1.5rem",
            color: theme.palette.primary.main,
          },
          [theme.breakpoints.up("md")]: {
            transform: "scale(1.2)",
          },
        },
      },
    },
    DirectionCardActions: {
      styleOverrides: {
        root: {
          gap: theme.spacing(1),
          height: "auto",
          padding: 0,
          display: "flex",
          flexDirection: "row-reverse",
          justifyContent: "center",
          "&>:not(:first-of-type)": {
            marginLeft: 0,
          },
        },
        actionButton: {
          width: "140px",
          borderRadius: "4px",
          textTransform: "uppercase",
          // !NOTE: Disable directory-mobile-standard.theme style
          [theme.breakpoints.down("sm")]: {
            fontWeight: "inherit",
            "&.MuiButton-outlined": {
              borderColor: "inherit",
            },
            "& .MuiButton-startIcon": {
              marginRight: theme.spacing(0.5),
            },
          },
        },
      },
    },
    AppDirectionOverview: {
      defaultProps: {},
      styleOverrides: {
        root: {},
        actionButtonWrapper: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: theme.spacing(0, 1),
          gap: theme.spacing(1),
        },
        container: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          alignItems: "start",
          position: "fixed",
          top: "unset",
          right: 0,
          left: 0,
          bottom: 0,
          margin: 0,
          minHeight: 235,
          zIndex: theme.zIndex.modal,
        },
        cardContainer: {
          gap: theme.spacing(5),
          padding: theme.spacing(3, 2, 4, 2),
          "button, a": { pointerEvents: "all" },
          display: "flex",
          flexDirection: "column",
          borderRadius: "8px 8px 0 0",
          height: mixins.directionCard.height,
          width: "100%",
        },
        cardBody: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
        },
        cardAction: {},
        headerWrapper: {
          display: "flex",
          justifyContent: "space-between",
          padding: theme.spacing(1.5, 2),
          [theme.breakpoints.up("sm")]: {
            maxWidth: mixins.mobileDirectionSearch.width,
          },
        },
        locationHeaderWrapper: {
          display: "flex",
          justifyContent: "space-between",
        },
        locationContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(0.5),
        },
        primaryText: {
          fontWeight: 400,
          fontSize: "0.875rem",
          margin: 0,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
          WebkitLineClamp: 1,
          overflow: "hidden",
          maxWidth: "140px",
        },
        secondaryText: {
          color: theme.palette.text.secondary,
          textTransform: "uppercase",
          fontWeight: 400,
          fontSize: "0.75rem",
        },
        stepCardContainer: {
          padding: theme.spacing(4, 2),
          "button, a": { pointerEvents: "all" },
          display: "flex",
          flexDirection: "column",
          borderRadius: "8px 8px 0 0",
          height: mixins.stepOverviewCard.height,
          width: "100%",
        },
        stepCardBody: {
          position: "relative",
          "button, a": { pointerEvents: "all" },
          "&:after": {
            content: "''",
            display: "inline-block",
            height: "20px",
            background: `linear-gradient(180deg, rgba(255, 255, 255, 0.00) 10%, ${theme.palette.background.default} 90%)`,
            zIndex: 1,
            position: "absolute",
            bottom: "-1px",
            left: 0,
            right: 0,
          },
        },
        stepper: {
          maxHeight: mixins.stepOverviewContent.height,
          paddingBottom: theme.spacing(2.5), // Prevent overlapping from bottom gradient effect.
          overflowY: "auto",
          gap: theme.spacing(2),
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          "& .MuiStep-vertical": {
            ":not(:last-of-type)": {
              "& .MuiStepLabel-labelContainer": {
                borderBottom: "none",
              },
            },
            "& .MuiStepLabel-labelContainer": {
              padding: 0,
            },
          },
        },
        originStep: {},
        destinationStep: {
          "& .MuiStepLabel-iconContainer": {
            "& .MuiBox-root": {
              borderColor: "#8E8C8D",
              "& .MuiAvatar-root": {
                backgroundColor: "#8E8C8D",
                border: "none",
              },
            },
          },
        },
        stepIconContainer: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: `1px solid ${theme.palette.primary.main}`,
          minWidth: "24px",
          height: "24px",
          borderRadius: "50%",
        },
        stepAvatar: {
          margin: 0,
          width: "18px",
          height: "18px",
          backgroundColor: theme.palette.primary.main,
          border: `0.5px solid ${theme.palette.primary.main}`,
          "& .MuiSvgIcon-root": {
            width: "12px",
            height: "12px",
          },
        },
        backButton: {
          display: "flex",
          padding: 0,
          borderRadius: "4px",
          width: "32px",
          height: "32px",
          minHeight: "32px",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.10)",
          "& .MuiSvgIcon-root": {
            width: "16px",
            height: "16px",
          },
        },
        durationText: {
          position: "absolute",
          bottom: "-26px",
          paddingBottom: theme.spacing(1),
          left: "50%",
          transform: "translateX(-50%)",
          display: "inline-block",
          minWidth: "78px",
          borderRadius: "9999px",
          padding: theme.spacing(0.5, 1),
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.text.primary,
          fontSize: "0.75rem",
          textAlign: "center",
          lineHeight: 1.5,
        },
      },
    },
    AppDirectionSearch: {
      styleOverrides: {
        paper: {
          borderRadius: "64px",
          padding: theme.spacing(1, 1.25),
          display: "flex",
          alignItems: "center",
          height: "40px",
        },
        formControlLabel: {
          textTransform: "uppercase",
          margin: 0,
          "& .MuiFormControlLabel-label": {
            fontSize: "0.75rem",
            fontWeight: 500,
            marginLeft: theme.spacing(1),
          },
        },
      },
    },
    AppNavigationStep: {
      styleOverrides: {
        root: {},
        container: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          alignItems: "start",
          position: "fixed",
          top: "unset",
          right: 0,
          left: 0,
          bottom: 0,
          margin: 0,
          minHeight: 202,
          zIndex: theme.zIndex.modal,
          height: "auto",
          // !NOTE: Disable directory-mobile-standard.theme style
          padding: 0,
        },
        cardContainer: {
          gap: theme.spacing(5),
          padding: theme.spacing(3, 2, 4, 2),
          "button, a": { pointerEvents: "all" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          borderRadius: "8px 8px 0 0",
          height: "auto",
          maxHeight: mixins.stepCard.height,
          width: "100%",
          boxShadow: "none",
          // !NOTE: Disable directory-mobile-standard.theme style
          marginLeft: "inherit",
          marginRight: "inherit",
          [theme.breakpoints.up("sm")]: {
            maxWidth: "unset",
            margin: theme.spacing(0, 6, 6, 6),
          },
        },
        cardBody: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
        },
        cardAction: {
          display: "flex",
          gap: theme.spacing(9),
          justifyContent: "center",
          alignItems: "center",
        },
        actionButtonGroupContainer: {
          display: "flex",
          gap: theme.spacing(3),
          justifyContent: "center",
          alignItems: "center",
        },
        actionButtonWrapper: {
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(2),
        },
        originIconContainer: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: `1px solid ${theme.palette.primary.main}`,
          minWidth: "24px",
          height: "24px",
          borderRadius: "50%",
        },
        destinationIconContainer: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: `1px solid #8E8C8D`,
          minWidth: "24px",
          height: "24px",
          borderRadius: "50%",
          "& .MuiAvatar-root": {
            backgroundColor: "#8E8C8D",
            border: "none",
          },
          "&.is-current-step": {
            border: `1px solid ${theme.palette.primary.main}`,
            "& .MuiAvatar-root": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
        locationAvatar: {
          margin: 0,
          width: "18px",
          height: "18px",
          backgroundColor: theme.palette.primary.main,
          border: `0.5px solid ${theme.palette.primary.main}`,
          "& .MuiSvgIcon-root": {
            width: "12px",
            height: "12px",
            display: "inline-block",
          },
        },
        overviewProgressContainer: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          width: "100%",
          gap: theme.spacing(1),
        },
        stepProgressBar: {
          display: "block",
          margin: theme.spacing(-2, 0),
        },
        descriptionContainer: {
          position: "relative",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          minWidth: "280px",
          height: "auto",
          minHeight: "30px",
          borderRadius: "9999px",
          padding: theme.spacing(1, 2),
          backgroundColor: "#F6F6F6",
          color: theme.palette.text.primary,
          marginBottom: theme.spacing(1.5),
          ":after": {
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            bottom: "-11px",
            content: "''",
            display: "inline-block",
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderTop: "12px solid #F6F6F6",
          },
        },
        descriptionText: {
          textAlign: "center",
          fontSize: "0.875rem",
          display: "-webkit-box",
          lineHeight: 1.5,
          textOverflow: "ellipsis",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          wordBreak: "break-word",
        },
        headerWrapper: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          top: "unset",
        },
        iconNavButton: {
          display: "flex",
          alignItems: "center",
          color: theme.palette.primary.main,
          padding: theme.spacing(1),
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
        exitButton: {
          height: "40px",
          minWidth: "136px",
          textTransform: "uppercase",
          // !NOTE: Disable directory-mobile-standard.theme style
          backgroundColor: "transparent",
          borderColor: theme.palette.error.light,
          color: theme.palette.text.error,
          fontWeight: 500,
          "& .MuiSvgIcon-root": {
            fill: `inherit`,
          },
          "&:hover": {
            backgroundColor: `inherit`,
          },
        },
        originIcon: {},
        destinationIcon: {},
      },
    },
    StepProgressBar: {
      styleOverrides: {
        wrapper: {
          width: "100%",
          overflowX: "scroll",
          padding: theme.spacing(1, 0),
          marginTop: 0,
          scrollbarWidth: "none", // Hide the scrollbar for firefox
          "&::-webkit-scrollbar": {
            display: "none", // Hide the scrollbar for WebKit browsers (Chrome, Safari, Edge, etc.)
          },
          "&-ms-overflow-style:": {
            display: "none", // Hide the scrollbar for IE
          },
        },
        stepper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 0,
          "& .MuiStepLabel-iconContainer": {
            padding: 0,
          },
          "& .step": {
            width: "20px",
            height: "20px",
            fontSize: "0.75rem",
            "& svg": {
              height: "16px",
              width: "16px",
            },
          },
          "& .destinationStep": {
            display: "none",
          },
        },
        originIcon: {
          display: "none",
        },
        connector: {
          "& .MuiStepConnector-line": {
            height: "2px",
            border: 0,
            minWidth: 36,
            backgroundColor: theme.palette.grey[200],
            borderRadius: 1,
          },
          "&.Mui-active": {
            "& .MuiStepConnector-line": {
              backgroundColor: theme.palette.primary.main,
            },
          },
          "&.Mui-completed": {
            "& .MuiStepConnector-line": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
      },
    },
    AppFeatureDetail: {
      styleOverrides: {
        root: {
          position: "relative",
          overflow: "initial",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
          padding: theme.spacing(0, 2, 3),
        },
        swipeableDrawer: {
          "& .MuiSwipeableDrawer-puller": {
            display: "none",
          },
        },
        swipeableDrawerGlobal: {
          ".MuiDrawer-root > .MuiPaper-root": {
            height: mixins.placeDetail.drawerBleeding.height
              ? `calc(67% - ${mixins.placeDetail.drawerBleeding.height}px)`
              : "auto",
          },
        },
        section: {
          margin: 0,
        },
        galleryImage: {
          objectFit: "cover",
          height: "92px",
          width: "163px",
          display: "block",
          boxShadow: "none",
          borderRadius: 0,
          cursor: "pointer",
        },
        galleryCarousel: {
          "& .splide__track": {
            margin: 0,
            padding: 0,
            marginLeft: theme.spacing(-2.25),
            marginRight: theme.spacing(-2),
          },
        },
        galleryCarouselItem: {},
        promotionImage: {
          objectFit: "cover",
          height: "152px",
          width: "84px",
          display: "block",
          boxShadow: "none",
          borderRadius: 0,
          cursor: "pointer",
        },
        promotionCarousel: {
          "& .splide__track": {
            margin: 0,
            padding: 0,
            marginLeft: theme.spacing(-2.25),
            marginRight: theme.spacing(-2),
          },
        },
        promotionCarouselItem: {},
        divider: {
          borderColor: theme.palette.divider,
          borderWidth: "0.5px",
          marginLeft: 0,
          marginRight: 0,
        },
        descriptionText: {
          fontSize: "0.875rem",
          color: theme.palette.text.secondary,
        },
        sectionTitle: {
          fontSize: "0.875rem",
          fontWeight: "400",
          textTransform: "uppercase",
          marginBottom: theme.spacing(1),
          color: theme.palette.text.secondary,
          paddingLeft: theme.spacing(1),
          borderLeft: `2px solid ${theme.palette.primary.main}`,
        },
        bleedWrapper: {
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          height: mixins.placeDetail.drawerBleeding.height,
        },
        contentWrapper: {},
        headerWrapper: {
          position: "fixed",
          left: 0,
          top: 0,
          paddingLeft: theme.spacing(2),
          paddingTop: theme.spacing(1.5),
          zIndex: theme.zIndex.drawer + 1,
        },
        backButton: {
          display: "flex",
          padding: 0,
          borderRadius: "4px",
          width: "32px",
          height: "32px",
          minHeight: "32px",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.10)",
          "& .MuiSvgIcon-root": {
            width: "16px",
            height: "16px",
          },
        },
      },
    },
    FeatureSummary: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          height: "100%",
          padding: theme.spacing(4, 2, 0),
        },
        title: {
          fontSize: "1rem",
          fontWeight: "700",
          maxWidth: "180px",
        },
        titleContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        logoContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          width: "40px",
          height: "40px",
          borderRadius: 0,
        },
        logoImage: {
          width: "inherit",
          height: "inherit",
          borderRadius: 0,
          backgroundColor: theme.palette.primary.main,
          "& .MuiSvgIcon-root": {
            color: theme.palette.text.primary,
            width: "20px",
            height: "20px",
          },
        },
        venueLogoContainer: {
          width: "60px",
          display: "inline-flex",
          justifyContent: "unset",
        },
        venueLogoImage: {},
        categoryIcon: {},
        actionContainer: {},
        navigationButton: {
          pointerEvents: "all",
          textTransform: "uppercase",
          padding: theme.spacing(1),
          lineHeight: 1,
          fontSize: "0.875rem",
        },
        headerContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: theme.spacing(1, 0),
        },
        infoList: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(0.5),
        },
        infoListItem: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        infoText: {
          fontSize: "0.875rem",
        },
        iconWrapper: {
          display: "flex",
          justifyContent: "center",
          "& .MuiSvgIcon-root": {
            height: "16px",
            width: "16px",
            color: theme.palette.text.primary,
            "& .highlight": {
              fill: theme.palette.primary.main,
            },
          },
        },
      },
    },
    DirectionStep: {
      styleOverrides: {
        originIcon: {
          fill: theme.palette.primary.main,
          width: 37,
          height: 37,
        },
        destinationIcon: {
          fill: theme.palette.error.main,
          width: 28,
          height: 47,
        },
        highlightedText: {
          color: theme.palette.primary.main,
          textAlign: "inherit",
          fontWeight: "700",
          lineHeight: "inherit",
          fontSize: "inherit",
        },
      },
    },
    DirectionStepItem: {
      styleOverrides: {
        root: {
          "& .MuiStepLabel-iconContainer": {
            paddingRight: theme.spacing(1),
          },
          "& .MuiStepLabel-labelContainer": {
            padding: 0,
          },
          ":not(:first-of-type, :last-of-type)": {
            padding: 0,
            "& .MuiListItemText-primary": {
              fontSize: "0.875rem",
              fontWeight: 400,
            },
          },
          "&:first-of-type": {
            paddingBottom: theme.spacing(2),
            marginBottom: 0,
            borderBottom: "0.5px solid #C7C6C6",
            "& .MuiStepLabel-iconContainer": {
              paddingLeft: 0,
              paddingRight: theme.spacing(1),
            },
            "& .MuiListItemText-primary": {
              fontSize: "0.875rem",
              fontWeight: 400,
              textTransform: "uppercase",
              color: theme.palette.text.secondary,
            },
            "& .MuiListItemText-secondary": {
              color: theme.palette.text.primary,
            },
            "& .MuiStepLabel-labelContainer": {
              padding: 0,
              "& .MuiListItemText-root": {
                display: "flex",
                flexDirection: "column",
                gap: theme.spacing(0.5),
              },
            },
          },
          "&:last-of-type": {
            paddingTop: theme.spacing(2),
            marginTop: 0,
            borderTop: "0.5px solid #C7C6C6",
            "& .MuiListItemText-primary": {
              fontSize: "0.875rem",
              fontWeight: 400,
              textTransform: "uppercase",
              color: theme.palette.text.secondary,
            },
            "& .MuiListItemText-secondary": {
              color: theme.palette.text.primary,
            },
            "& .MuiStepLabel-iconContainer": {
              paddingLeft: 0,
              paddingRight: theme.spacing(1),
            },
            "& .MuiStepLabel-labelContainer": {
              padding: 0,
              "& .MuiListItemText-root": {
                display: "flex",
                flexDirection: "column",
                gap: theme.spacing(0.5),
              },
            },
          },
          "& .MuiStepLabel-vertical": {
            padding: 0,
          },
        },
        listItem: {
          "& .MuiListItemText-primary": {
            whiteSpace: "normal",
            color: theme.palette.text.primary,
            fontSize: theme.typography.body2.fontSize,
            fontWeight: theme.typography.subtitle2.fontWeight,
          },
          "& .MuiListItemText-secondary": {
            fontSize: "0.875rem",
          },
          "& .MuiListItemSecondaryAction-root": {
            marginLeft: "auto",
            position: "static",
            transform: "none",
            color: theme.palette.text.secondary,
            right: 0,
            "& .MuiSvgIcon-root": {
              width: "16px",
              height: "16px",
            },
            "& .MuiIconButton-root": {
              padding: 0,
            },
          },
        },
      },
    },
    DirectionStepIcon: {
      styleOverrides: {
        root: {
          display: "flex",
          width: "24px",
          height: "24px",
          padding: theme.spacing(0.85),
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "4px",
          backgroundColor: "#F6F6F6",
          fontSize: "0.875rem",
          fontWeight: 400,
          color: theme.palette.text.primary,
        },
      },
    },
    DirectionSearchInput: {
      styleOverrides: {
        directionSearchWrapper: {
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.10)",
          background: theme.palette.background.paper,
          padding: theme.spacing(1),
          borderRadius: "8px",
          display: "flex",
        },
        backIconWrapper: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: theme.spacing(0, 0.75),
          marginRight: theme.spacing(1),
        },
        directionWrapper: {
          flexGrow: 1,
          display: "flex",
        },
        switchIconWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: theme.spacing(0, 0.75),
          marginLeft: theme.spacing(1),
        },
        directionInputWrapper: {
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        },
        directionIconWrapper: {
          display: "flex",
          justifyContent: "space-evenly",
          flexDirection: "column",
          marginRight: theme.spacing(1),
        },
        directionInput: {
          fontSize: "0.875rem",
          fontWeight: 400,
          flexGrow: 1,
          padding: theme.spacing(1),
          "& .MuiInputBase-input": {
            padding: 0,
          },
        },
        iconButton: {
          color: theme.palette.text.primary,
          fontSize: "1.5rem",
          margin: "-5px",
        },
        backIconButton: {
          "& .MuiSvgIcon-root": {
            width: "12px",
            height: "12px",
          },
        },
        switchIconButton: {
          "& .MuiSvgIcon-root": {
            width: "20px",
            height: "20px",
          },
        },
        connectorIcon: {
          color: theme.palette.text.primary,
        },
        originIcon: {
          width: "20px",
          height: "20px",
          "& .highlight": {
            fill: theme.palette.primary.main,
          },
        },
        destinationIcon: {
          width: "20px",
          height: "20px",
          color: theme.palette.primary.main,
          "& .highlight": {
            fill: theme.palette.primary.main,
          },
        },
        divider: {
          margin: 0,
          borderBottomWidth: "1px",
          borderColor: "theme.palette.divider,",
        },
        clearIconButton: {
          color: theme.palette.text.primary,
          fontSize: "1.5rem",
          margin: "-5px",
          "& .MuiSvgIcon-root": {
            height: "12px",
            width: "12px",
          },
        },
      },
    },
    EmptyData: {
      styleOverrides: {
        primaryText: {
          textTransform: "uppercase",
          fontWeight: 400,
          fontSize: "1.125rem",
        },
        secondaryText: {
          fontSize: "1rem",
        },
        root: {
          color: "#C7C6C6",
        },
        iconWrapper: {
          "& .MuiSvgIcon-root": {
            color: "#C7C6C6",
            height: "40px",
            width: "40px",
          },
          marginBottom: 0,
        },
      },
    },
    AppOrdinalSelector: {
      styleOverrides: {
        root: {
          right: theme.spacing(1),
          left: "none",
          backgroundColor: "transparent",
          boxShadow: "none",
          gap: theme.spacing(1),
          display: "flex",
          flexDirection: "column",
          bottom: "203px",
          width: "40px",
        },
        listItemButton: {
          height: "40px",
          width: "40px",
          borderRadius: "4px",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.10)",
          fontSize: "1rem",
        },
      },
    },
    OrdinalSelector: {
      styleOverrides: {
        root: {
          height: "100%",
          alignItems: "center",
          display: "flex",
        },
        button: {
          width: "40px",
          height: "40px",
          minWidth: "40px",
          borderRadius: "4px",
          fontSize: "1rem",
          padding: theme.spacing(0.75),
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.10)",
          lineHeight: "normal",
        },
        listContainer: {
          width: "100%",
          marginTop: theme.spacing(-7), //toolbar height
          position: "relative",
          "&:after": {
            content: "''",
            display: "inline-block",
            height: "50px",
            width: "100%",
            zIndex: 1,
            position: "absolute",
            bottom: 0,
            pointerEvents: "none",
          },
          "&:before": {
            content: "''",
            display: "inline-block",
            height: "50px",
            width: "100%",
            zIndex: 1,
            position: "absolute",
            top: 0,
            pointerEvents: "none",
          },
        },
        list: {
          maxHeight: "40vh",
          overflow: "hidden auto",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          padding: 0,
          paddingBottom: "calc(25% + 19px)", // 19 = listitem height/2
          paddingTop: "calc(25% + 19px)", // 19 = listitem height/2
        },
        listItemButton: {
          width: "100%",
          padding: theme.spacing(1),
          maxHeight: "38px",
          fontSize: "1rem",
          justifyContent: "center",
          "&.Mui-selected": {
            color: theme.palette.primary.main,
            fontWeight: 700,
          },
        },
      },
    },
    OSLanguageButton: {
      styleOverrides: {
        root: {
          borderRadius: "9999px",
          minHeight: "34px",
          minWidth: "154px",
          padding: theme.spacing(1, 2),
          textTransform: "uppercase",
          color: theme.palette.text.primary,
          "& .MuiButton-endIcon": {
            marginLeft: theme.spacing(0.5),
            "& .MuiSvgIcon-root": {
              width: "18px",
              height: "18px",
              color: theme.palette.primary.main,
            },
          },
        },
        highlightedText: {
          fontWeight: "700",
          marginLeft: theme.spacing(1),
          color: theme.palette.primary.main,
        },
        dialog: {},
        dialogContent: {
          height: "100%",
          alignItems: "center",
          display: "flex",
        },
        button: {
          width: "32px",
          height: "32px",
          minWidth: "32px",
          borderRadius: "4px",
          fontSize: "0.875rem",
        },
        listContainer: {
          width: "100%",
          marginTop: theme.spacing(-7), //toolbar height
          position: "relative",
          "&:after": {
            content: "''",
            display: "inline-block",
            height: "50px",
            width: "100%",
            zIndex: 1,
            position: "absolute",
            bottom: 0,
            pointerEvents: "none",
          },
          "&:before": {
            content: "''",
            display: "inline-block",
            height: "50px",
            width: "100%",
            zIndex: 1,
            position: "absolute",
            top: 0,
            pointerEvents: "none",
          },
          maxHeight: "40vh",
        },
        list: {
          maxHeight: "40vh",
          overflow: "hidden auto",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          padding: 0,
          paddingBottom: "calc(25% + 19px)", // 19 = listitem height/2
          paddingTop: "calc(25% + 19px)", // 19 = listitem height/2
        },
        listItemButton: {
          width: "100%",
          padding: theme.spacing(1),
          maxHeight: "38px",
          justifyContent: "center",
          fontSize: "1rem",
          "&.Mui-selected": {
            backgroundColor: "#231f200d",
            color: theme.palette.primary.main,
            fontWeight: 700,
          },
        },
      },
    },
    Dialog: {
      styleOverrides: {
        root: {},
        titleText: {
          flexGrow: 1,
          fontWeight: 400,
          textAlign: "center",
          padding: theme.spacing(0, 3),
        },
        toolbar: {
          backgroundColor: "transparent",
          color: theme.palette.text.primary,
        },
        appBar: {
          position: "sticky",
          background: "none",
          boxShadow: "none",
        },
        closeButton: {
          position: "absolute",
          zIndex: 999,
        },
      },
    },
    OSMenus: {
      styleOverrides: {
        body: { marginTop: theme.spacing(3) },
        navList: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
        },
        navListItem: {
          gap: theme.spacing(1),
          justifyContent: "center",
          "&.active": {
            background: "#231F200D",
          },
        },
        navListItemIcon: {
          minWidth: "unset",
          color: theme.palette.text.primary,
          "& .highlight": {
            fill: theme.palette.primary.main,
          },
        },
        navListItemText: {
          flex: "unset",
          textTransform: "uppercase",
          fontSize: "1.125rem",
          "&.active": {
            color: theme.palette.primary.main,
            "& .MuiTypography-root": {
              fontWeight: 700,
            },
          },
        },
        navListWrapper: {},
        languageSelectorWrapper: {
          display: "flex",
          justifyContent: "center",
          padding: theme.spacing(1.5),
          marginTop: theme.spacing(2),
        },
      },
    },
    VuiAdImageCarousel: {
      styleOverrides: {
        image: {
          width: "max(50vw, 257px)",
          aspectRatio: "9 / 16",
          objectFit: "cover",
          borderRadius: "4px",
          [theme.breakpoints.up("md")]: {
            aspectRatio: "9/16",
            width: "min(50vw, 450px)",
          },
        },
        carousel: {
          "& .splide__pagination__page": {
            background: theme.palette.common.white,
          },
          "& .splide__pagination__page.is-active": {
            width: "8px",
          },
        },
      },
    },
    ServiceCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "4px",
          overflow: "hidden",
          "&:first-of-type": {
            borderRadius: "4px",
          },
          "&:last-of-type": {
            borderRadius: "4px",
          },
          "&:before": {
            display: "none",
          },
          "&.Mui-expanded": {
            margin: 0,
          },
        },
        accordionSummary: {
          height: "70px",
          padding: theme.spacing(1, 2),
          gap: theme.spacing(3),
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
          ":after": {
            content: "''",
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            zIndex: 0,
            background: `linear-gradient(89deg, ${alpha(
              theme.palette.background.paper,
              0.9
            )} 49.87%, ${alpha(theme.palette.background.paper, 0)} 92.75%)`,
          },
          "& .MuiAccordionSummary-expandIconWrapper": {
            color: theme.palette.primary.main,
            "& .MuiSvgIcon-root": {
              width: "20px",
              height: "20px",
            },
          },
        },
        coverImage: {
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
          backgroundColor: "#ffffffcc",
          backgroundBlendMode: "lighten",
          backgroundSize: "cover",
          filter: "grayscale(100%)",
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          width: "60%",
        },
        summaryContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(2),
          alignItems: "center",
          zIndex: 1,
        },
        titleText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          WebkitLineClamp: 1,
          fontSize: "0.875rem",
          fontWeight: 700,
        },
        descriptionText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          wordBreak: "break-word",
          fontSize: "0.75rem",
        },
        serviceIconContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "32px",
          height: "32px",
          background: theme.palette.background.default,
        },
        serviceIcon: {
          color: theme.palette.primary.main,
          width: "20px",
          height: "20px",
        },
        infoContainer: {},
        accordionDetails: {
          padding: theme.spacing(1),
          backgroundColor: "#E8E8E8",
        },
        locationList: {
          padding: theme.spacing(0, 0.5, 0, 0),
          overflowY: "auto",
          maxHeight: "160px",
          overflow: "hidden auto",
          "::-webkit-scrollbar": {
            width: "4px",
          },
          "::-webkit-scrollbar-track": {
            background: "#C7C6C6",
          },
          "::-webkit-scrollbar-thumb": {
            background: theme.palette.primary.main,
          },
        },
        locationListItem: {
          padding: theme.spacing(1, 2),
          height: 40,
        },
        locationTitleText: {
          "& .MuiListItemText-primary": {
            fontSize: "0.75rem",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            WebkitLineClamp: 1,
            textOverflow: "ellipsis",
            maxWidth: "80%",
          },
        },
        locationNavigateButton: {
          color: theme.palette.primary.main,
          marginRight: theme.spacing(-2.5),
          "& .MuiSvgIcon-root": {
            width: "20px",
            height: "20px",
          },
        },
      },
    },
    VerticalDirectionImageDialog: {
      styleOverrides: {
        root: {
          overflow: "hidden",
          zIndex: 1,
          "& .MuiPaper-elevation": {
            maxWidth: "240px",
            width: "240px",
            height: "104px",
          },
        },
        container: {
          backgroundColor: theme.palette.background.paper,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(1.5),
          padding: theme.spacing(1.5),
        },
        image: {
          height: 80,
          width: 80,
        },
        descriptionContainer: {
          display: "flex",
          flexDirection: "column",
        },
        highlightedText: {
          fontWeight: 700,
        },
        headerContainer: {
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        primaryText: {
          fontWeight: 700,
          color: theme.palette.primary.main,
        },
        secondaryText: {
          display: "none",
        },
        arrowIcon: {
          width: "24px",
          height: "24px",
        },
      },
    },
  },
})
